/**
 * Checks if an object contains all specified keys.
 * @param {object} obj - The object to check.
 * @param {Array<string>} keys - The keys to verify in the object.
 * @returns {boolean} - True if the object contains all keys, otherwise false.
 */
export const containsAllKeys = ( obj, keys ) => keys.every(
  key => Object.prototype.hasOwnProperty.call( obj, key ),
);

/**
 * Validates if all objects in an array contain all keys specified in a schema.
 * @param {Array<object>} array - The array of objects to validate.
 * @param {Array<string>} schema - The keys to verify in each object.
 * @returns {boolean} - True if all objects contain all keys, otherwise false.
 */
export const arrayContentsContainsAllKeys = ( array, schema ) => array.every(
  obj => containsAllKeys( obj, schema ),
);
